import { useState, useEffect } from "react";
import { saveUserAttendance, fetchWorkingDaysData, fetchResourceData } from "../Api/UserAttendance";
import { Container, Form, Button, Row, Col, Accordion, AccordionItem, AccordionBody, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import Sample14 from "../Components/Logo";
import { useAuth } from "../Context/AuthContext";

const UserAttendance = () => {
  const [loading, setLoading] = useState(false);
  const [workingDaysData, setWorkingDaysData] = useState([]);
  const [resourceData, setResourceData] = useState([]);
  const [attendanceData, setAttendanceData] = useState({
    workingDaysId: "",
    resourceId: "",
    salaryDays: "",
  });
  const { user } = useAuth();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [workingDays, resources] = await Promise.all([
          fetchWorkingDaysData(user?.organisationId),
          fetchResourceData(user?.organisationId),
        ]);
        setWorkingDaysData(workingDays);
        setResourceData(resources);
      } catch (error) {
        toast.error("Error fetching data: " + error.message);
      }
    };
    fetchData();
  }, [user]);

  const handleChange = (e) => {
    setAttendanceData({ ...attendanceData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveUserAttendance(attendanceData);
      toast.success("User Attendance Saved Successfully");
      setAttendanceData({
        workingDaysId: "",
        resourceId: "",
        salaryDays: "",
      });
    } catch (error) {
      toast.error("Error Saving Attendance: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container asset-master-fields">
      <h2 className="fields-title">User Attendance Form</h2>

      <Form onSubmit={handleSubmit} className="fields-form" noValidate>
        <Accordion defaultActiveKey="0" className="asset-master-accordion">
          <AccordionItem eventKey="0">
            <AccordionBody>
              <Row className="g-3">
                {/* Working Days */}
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group controlId="workingDaysId">
                    <Form.Label>
                      Working Days ID <span className="text-red">**</span>
                    </Form.Label>
                    <Form.Select
                      name="workingDaysId"
                      value={attendanceData.workingDaysId}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Working Days ID</option>
                      {workingDaysData.map((item) => (
                        <option key={item.workingDaysId} value={item.workingDaysId}>
                          {item.workingMonth}-{item.workingYear}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                {/* Resource */}
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group controlId="resourceId">
                    <Form.Label>
                      Resource ID <span className="text-red">**</span>
                    </Form.Label>
                    <Form.Select
                      name="resourceId"
                      value={attendanceData.resourceId}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Resource ID</option>
                      {resourceData.map((resource) => (
                        <option key={resource.resourceId} value={resource.resourceId}>
                          {resource.resourceId} - {resource.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                {/* Salary Days */}
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group controlId="salaryDays">
                    <Form.Label>
                      Salary Days <span className="text-red">**</span>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      name="salaryDays"
                      value={attendanceData.salaryDays}
                      onChange={handleChange}
                      min="0"
                      max="31"
                      required
                      placeholder="e.g., 22"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </AccordionBody>
          </AccordionItem>
        </Accordion>

        <div className="fields-btn-container mt-3">
          <Button
            type="submit"
            className="fields-submit"
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Saving…
              </>
            ) : (
              "Save Attendance"
            )}
          </Button>
        </div>
      </Form>

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </div>
  );
};

export default UserAttendance;